module.exports = __webpack_public_path__ + "assets/stand11w.9f2d5d9e71e71ac162630640edf5abcd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/stand11w.png
 ** module id = 184
 ** module chunks = 0
 **/